/*
npm start PARA COMPILAR
npm run build PARA COMPILAR Y MINIFICAR
*/

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { FC, useCallback, useEffect, useState } from 'react';

import { HomePage } from './subpages/home';
import { Page404 } from './subpages/page404';

import { ConfigAirportPage } from './subpages/config/airport';
import { ConfigBeltsPage } from './subpages/config/belts';
import { ConfigCountersPage } from './subpages/config/counters';
import { ConfigDisplaysPage } from './subpages/config/displays';
import { ConfigGatesPage } from './subpages/config/gates';

import { FlightsAddPage } from './subpages/flights/add';
import { FlightsEditPage } from './subpages/flights/edit';
import { FlightsGridPage } from './subpages/flights/grid';
import { FlightsSearchPage } from './subpages/flights/search';






import { UserLoginPage } from './subpages/user/login';
import { UserLogoffPage } from './subpages/user/logoff';

import { SystemSecurityAPIKeysPage } from './subpages/system/security/apikeys';
import { SystemSecurityWhiteListPage } from './subpages/system/security/whitelist';

import { SystemUsersAddPage } from './subpages/system/users/add';
import { SystemUsersGroupEditPage } from './subpages/system/users/group.edit';
import { SystemUsersGroupsPage } from './subpages/system/users/groups';

import { SystemUsersListPage } from './subpages/system/users/list';






import { useGlobalState } from '../context/GlobalStateContext';
import { UserPasswordPage } from './subpages/user/password';



import { Error404 } from '../../components/errors/e404';
import { fetchWithWatch } from '../../hooks/fetchWithWatch';
import { getCookie, getUrlVersion, setCookie } from '../commons/functions';
import { ConfigBeltsEditPage } from './subpages/config/belts.edit';
import { ConfigDisplaysEditPage } from './subpages/config/displays.edit';
import { ConfigStatusesPage } from './subpages/config/statuses';
import { ConfigStatusesEditPage } from './subpages/config/statuses.edit';
import { BreadPage } from './subpages/default';
import { FlightsDeletePage } from './subpages/flights/delete';
import { MarketingMediaUploadPage } from './subpages/marketing/media.upload';
import { MarketingMediasPage } from './subpages/marketing/medias';
import { MarketingProgramEditPage } from './subpages/marketing/program.edit';
import { MarketingProgramsPage } from './subpages/marketing/programs';
import { SystemLogsPage } from './subpages/system/logs';
import { SystemSecurityAPIKeysAddPage } from './subpages/system/security/apikeys.add';
import { SystemSecurityAPIKeysEditPage } from './subpages/system/security/apikeys.edit';
import { Template } from './subpages/system/template';
import { SystemSecurityRoutingPage } from './subpages/system/users/routing';


const pages: Record<string, FC> = {

  'user/login': UserLoginPage,
  'user/logoff': UserLogoffPage,

  'flights/grid': FlightsGridPage,
  'flights/add': FlightsAddPage,
  'flights/search': FlightsSearchPage,
  'flights/edit': FlightsEditPage,
  'flights/delete': FlightsDeletePage,

  'config/airport': ConfigAirportPage,
  'config/belts': ConfigBeltsPage,
  'config/belts.edit': ConfigBeltsEditPage,
  'config/gates': ConfigGatesPage,
  'config/displays': ConfigDisplaysPage,
  'config/displays.edit': ConfigDisplaysEditPage,

  'config/counters': ConfigCountersPage,
  'config/statuses': ConfigStatusesPage,
  'config/statuses.edit': ConfigStatusesEditPage,



  'system/users/add': SystemUsersAddPage,
  'system/users/list': SystemUsersListPage,
  'system/users/groups': SystemUsersGroupsPage,
  'system/users/group.edit': SystemUsersGroupEditPage,

  'system/logs': SystemLogsPage,

  'system/security/whitelist': SystemSecurityWhiteListPage,
  'system/security/apikeys': SystemSecurityAPIKeysPage,
  'system/security/apikeys.edit': SystemSecurityAPIKeysEditPage,
  'system/security/apikeys.add': SystemSecurityAPIKeysAddPage,
  'system/security/routing': SystemSecurityRoutingPage,

  'marketing/programs': MarketingProgramsPage,
  'marketing/medias': MarketingMediasPage,
  'marketing/media.upload': MarketingMediaUploadPage,
  'marketing/program.edit': MarketingProgramEditPage,


  'user/password': UserPasswordPage,
  'home': HomePage,
  'page404': Page404,


  'system/routing/template': Template,


  'flights/default': BreadPage,
  'system/default': BreadPage,
  'system/users/default': BreadPage,
  'config/default': BreadPage,
  'system/security/default': BreadPage,
  'marketing/default': BreadPage,
};

function NotFound() {
  return <Error404 />;
}

interface RouterProps {
  initialPage: string;
}

// Helper functions (Improved)
function getHashPath(hash: string): string {
  const questionMarkIndex = hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    return hash.substring(1, questionMarkIndex);
  }
  return hash.substring(1);
}




export function Router({ initialPage }: RouterProps) {
  const [currentPagePath, setCurrentPage] = useState(getHashPath(window.location.hash) || initialPage);
  const { setReturnUrl, serverVersion, setServerVersion } = useGlobalState();
  //const { reloader, setReloader } = useGlobalState();
  const [initRouter, setInitRouter] = useState(true)
  const { data, setData } = useGlobalState();
  const { idUser, setIdUser } = useGlobalState();
  const { idAirport, setIdAirport } = useGlobalState();


  const handleValidateStatus = useCallback(async () => {
    if (getCookie("JWT") !== "") return;
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/admins/session',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data.serverVersion)
        setServerVersion(data.serverVersion)
      else
        setServerVersion(0)
      if (data.code == 0) {
        console.log(data)
        if (data.UF) {
          console.log(data.UF)
          const updatedData = { ...data, UF: Number(data.UF) };
          setData(updatedData);
        }
        if (data.USD) {
          const updatedData = { ...data, USD: Number(data.USD) };
          setData(updatedData);
        }
        if (data.counters) {
          const updatedData = { ...data, counters: data.counters };
          setData(updatedData);
        }
        if (data.JWT && data.JWT && data.JWT !== "") {
          if (getCookie("JWT") != data.JWTR) {
            setCookie("JWT", data.JWT);
          }
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setInitRouter(false)
    }
  }, [initRouter]);

  useEffect(() => {
    const handler = () => {
      const newHash = getHashPath(window.location.hash);
      //const newReturnUrl = getHashParameter(window.location.hash, 'returnUrl');
      //setReturnUrl(newReturnUrl);
      setCurrentPage(newHash || initialPage);
    };

    window.addEventListener('hashchange', handler);
    handler(); //call handler to process initial hash

    return () => window.removeEventListener('hashchange', handler);
  }, [initialPage, setReturnUrl]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [currentPagePath]);

  useEffect(() => {
    let currentHash = (window.location.hash).replace("#", "") || '';

    if (!window.location.hash.startsWith("#user/")) {
      if (getCookie("JWT") === '') {
        window.location.hash = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;

        setIdUser(0); setIdAirport(0);
        console.log("6.-No JWT, redirect to login");
        return;
      } else if (isJWTExpired(getCookie("JWT"))) {
        console.log("5.-JWT Expired");

        setIdUser(0); setIdAirport(0);
        window.location.hash = `#user/login?t=2&returnUrl=${encodeURIComponent(currentHash)}`;
        return;
      } else {
        //handleValidateStatus();
      }
    }
  }, [currentPagePath, isJWTExpired, handleValidateStatus]);

  const CurrentPage = currentPagePath in pages ? pages[currentPagePath] : NotFound;
  return <CurrentPage />;
}

// ... (rest of your isJWTExpired and useRouter functions)
export const isJWTExpired = (token: string) => {
  if (!token) return true;
  try {
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return true;
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch (error) {
    console.error("Error decoding or parsing JWT:", error);
    return true;
  }
};

export function useRouter() {
  return {
    navigate: (newPage: string) => (location.hash = `#${newPage}`),
  };
}


